import React from "react";
import Layout from "../../components/layouts/layout";
import VentureRyteHero from "../../components/VentureRyte/VentureRyteHero";
import WhyVC2Section from "../../components/VentureRyte/WhyVC2Section";
import ComparisonTable from "../../components/VentureRyte/ComparisonTable";
import MMPRevolutionSection from "../../components/VentureRyte/MMPRevolutionSection";
import PowerhouseTeamSection from "../../components/VentureRyte/PowerhouseTeamSection";
import VentureEnablementModelSection from "../../components/VentureRyte/VentureEnablementModelSection";
import BOTGCCSection from "../../components/VentureRyte/BOTGCCSection";
import PricingModelsSection from "../../components/VentureRyte/PricingModelsSection";
import WhyChooseVC2Section from "../../components/VentureRyte/WhyChooseVC2Section";
import VentureRyteCTASection from "../../components/VentureRyte/VentureRyteCTASection";
import LPFooter from "../../components/LPFooter";
import "./ventureRyte.scss";
import { navigate } from "gatsby";

const VentureRytePage = () => {
  const scrollToForm = () => {
    // if (typeof window !== "undefined") {
    //   const formSection = document.getElementById("ventureryte-contact");
    //   if (formSection) {
    //     formSection.scrollIntoView({ behavior: "smooth" });
    //   }
    // }
    navigate("/contact-us");
  };

  return (
    <Layout
      seo={{
        title: "ventureRyte - Venture Capital 2.0 | digiRyte",
        ogtitle: "ventureRyte - Where Technology, Capital & Strategy Converge",
        description:
          "Build and scale your product with Technology Capital, not just cash. digiRyte combines Big 4 Lite strategy, Powerhouse engineering, TRL scoring, and MMP-first execution.",
        keywords:
          "venture capital 2.0, technology capital, MMP, TRL scoring, powerhouse team, startup engineering, BOT GCC, equity investment",
      }}
      isLandingPage={false}
      pageUrl={"/ventureryte"}
      redirectContactTo={"/contact-us"}
      handleClick={scrollToForm}
    >
      <div className="ventureryte-page">
        <VentureRyteHero />
        <WhyVC2Section />
        <ComparisonTable />
        <MMPRevolutionSection />
        <PowerhouseTeamSection />
        <VentureEnablementModelSection />
        <BOTGCCSection />
        <PricingModelsSection />
        <WhyChooseVC2Section />
        <VentureRyteCTASection onPrimaryClick={scrollToForm} />
      </div>
    </Layout>
  );
};

export default VentureRytePage;
